import { fetcher, SHOW_ERROR_PAGE_ON_FETCH_FAIL } from '@features/common';

/**
 * Headcount and Saudization figures. Employees without access get 403, which
 * the page shows itself instead of the global error screen.
 */
export function fetchWorkforceSummary() {
  return fetcher.get('/api/v1/hr/workforce-summary', {
    meta: { [SHOW_ERROR_PAGE_ON_FETCH_FAIL]: false },
  });
}
